import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PasswordMessageDialogueComponent } from '../password-message-dialogue/password-message-dialogue.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrl: './set-new-password.component.scss',
})
export class SetNewPasswordComponent {
  setNewPasswordForm: FormGroup;
  email: string = '';
  userType: string = '';
  name: string = '';
  customerReferenceId: string = '';
  passwordinputType: string = 'password';
  confirmPasswordinputTypes: string = 'password';
  constructor(
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.setNewPasswordForm = this.formBuilder.group({
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonService.passwordRegex),
        ],
      ],
      confirmPassword: ['', [Validators.required]],
    });
  }
  ngOnInit(): void {

    history.pushState(null, '', location.href);
    window.addEventListener('popstate', () => {
      window.location.href = '/login'; // Forces reload and redirects
    });
    
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getUserDetails();
  }
  getUserDetails() {
    this.route.queryParams.subscribe((params) => {
      if (params.hasOwnProperty('email') && params.hasOwnProperty('userType')) {
        this.email = decodeURIComponent(params['email']);
        this.userType = params['userType'] || '';

        if (this.email && this.userType) {
          this.email = this.commonService.Decrypt(this.email);
          this.userType = this.commonService.Decrypt(this.userType);
          if (this.email == '' || this.userType == '') {
            this.router.navigate(['/login']);
          }
        }
      }
    });
    // this is for the name  of the user
    const FormData = {
      Email: this.email,
      UserType: this.userType,
    };
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.User.getUserDetails;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            //this.toaster.success(response.Message);
            if (response.Data.UserIsPresent) {
              if (response.Data.UserName != null && response.Data.UserName != ' ' && response.Data.UserName != '') {
                this.name = response.Data.UserName;
              }
              if (response.Data.UserReferenceId) {
                this.customerReferenceId = response.Data.UserReferenceId;
              }
            } else {
              this.name = '';
            }
          } else {
            //this.toaster.error(response.Message);
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  onSubmit() {
    Object.keys(this.setNewPasswordForm.controls).forEach((key) => {
      const control = this.setNewPasswordForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
    const FormData = {
      Email: this.email,
      NewPassword: this.setNewPasswordForm.value.password,
      ConfirmPassword: this.setNewPasswordForm.value.confirmPassword,
    };
    if (FormData.NewPassword != FormData.ConfirmPassword) {
      this.toaster.error(this.translate.instant('PASSWORD_NOT_MATCH_TOASTER'));
      return;
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.resetPassword;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            //this.toaster.success(response.Message);
            const dialogRef = this.dialog.open(
              PasswordMessageDialogueComponent,
              {
                width: '600px',
                data: {
                  // data will be based on API response
                  passwordError: false,
                  message: 'RESET_PASSWORD_SUCCESS_MSG',
                  title: ''
                },
              }
            );

            dialogRef.afterClosed().subscribe((result: any) => {
              if (result) {
                this.router.navigate(['/login']);
              }
            });
          } else {
            this.toaster.error(this.translate.instant(response.Message));
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  changeInputType(input_type: any, fieldName: any) {
    if (fieldName == 'password') {
      if (input_type == 'password') {
        this.passwordinputType = 'text';
      } else {
        this.passwordinputType = 'password';
      }
    } else if (fieldName == 'confirmPassword') {
      if (input_type == 'password') {
        this.confirmPasswordinputTypes = 'text';
      } else {
        this.confirmPasswordinputTypes = 'password';
      }
    }
  }

  onSignup() {
    this.router.navigate(['/signup']);
  }
}
